import { createProxies } from "./proxies";

interface FontLoadingExportsMethods {
  LoadFont: (family: string, weight: string, isItalic: boolean) => Promise<void>;
}

export interface FontLoadingExports {
  FontLoading: FontLoadingExportsMethods;
}

export const {
  setup,
  loadFont,
} = createProxies<FontLoadingExportsMethods>([
  "LoadFont",
]);
